const state = {
    loader: true
};


const getters = {

    getLoaderStatus(state) {
        return state.loader;
    },

};

const actions = {

    showLoader({ commit }) {
        commit('SHOW_LOADER');
    },

    hideLoader({ commit }) {
        commit('HIDE_LOADER');
    }

};

const mutations = {

    'SHOW_LOADER'(state) {
        state.loader = true;
    },

    'HIDE_LOADER'(state) {
        state.loader = false;
    }
};

export default {
    mutations,
    actions,
    getters,
    state: state
};
